module.exports = __webpack_public_path__ + "img/0-sm.642534d3.jpg";